/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from "axios";
import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class FederalEntityRequest extends MainRequest{

    static addFederalEntity(data){
        return this.postSEC(ServicePath.FEDERAL_ENTITY_ADD, data)
    }

    static listAllFederalEntity(){
        return this.getSEC(ServicePath.FEDERAL_ENTITY_LIST_ALL)
    }

    static updateFederalEntity(data){
        return this.postSEC(ServicePath.FEDERAL_ENTITY_UPDATE, data)
    }

    static deleteFederalEntity(data, token){
        return axios.delete(ServicePath.FEDERAL_ENTITY_DELETE, data, token)
    }

}

